import { PropertyNotFoundError } from '@koolumbus/api/utils';
import type { GetServerSideProps } from 'next';
import { getMainLayout } from '../../components/layout/MainLayout';
import PropertyPage, {
  PropertyPageProps,
} from '../../components/properties/property-page/PropertyPage';
import { mapPropertyData, propertyDataSelect } from '../../lib/models';
import { prisma } from '../../lib/prisma';

export const getServerSideProps: GetServerSideProps<PropertyPageProps> = async (ctx) => {
  const propertyId = ctx.params!['propertyId'] as string;

  try {
    const prop = await prisma.property.findFirst({
      select: propertyDataSelect,
      where: {
        id: propertyId,
        public: true,
        archivedAt: null,
      },
    });

    if (!prop) {
      throw new PropertyNotFoundError();
    }

    const property = mapPropertyData({
      ...prop,
      location: prop.location!,
    });

    return {
      props: { property },
    };
  } catch (err) {
    console.error(err);
    return {
      notFound: true,
    };
  }
};

PropertyPage.getLayout = getMainLayout({ bg: 'white' });

export default PropertyPage;
